export default __webpack_public_path__ + "static/media/irInActive.dacc26ab.svg";